<script setup></script>

<template>
    <div class="mt-32 sm:mt-56 overflow-hidden">
        <div class="mx-auto max-w-7xl md:px-6 lg:px-8">
            <div
                class="grid grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:grid-cols-2 lg:items-start"
            >
                <div class="px-6 lg:px-0 lg:pr-4 lg:pt-4">
                    <div class="mx-auto max-w-2xl lg:mx-0 lg:max-w-lg">
                        <h2
                            class="text-base/7 font-semibold text-brand-dark dark:text-brand-accent"
                        >
                            <slot name="subtitle"></slot>
                        </h2>
                        <p
                            class="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 dark:text-gray-100 sm:text-5xl"
                        >
                            <slot name="title"></slot>
                        </p>
                        <slot name="content"></slot>
                    </div>
                </div>
                <div class="sm:px-6 lg:px-0">
                    <div
                        class="relative isolate overflow-hidden bg-light-to dark:bg-brand-light px-6 pt-8 sm:mx-auto sm:max-w-2xl sm:rounded-2xl sm:pl-16 sm:pr-0 sm:pt-16 lg:mx-0 lg:max-w-none"
                    >
                        <div
                            class="absolute -inset-y-px -left-3 -z-10 w-full origin-bottom-left skew-x-[-30deg] bg-light-from opacity-20 ring-1 ring-inset ring-white"
                            aria-hidden="true"
                        />
                        <div class="mx-auto max-w-2xl sm:mx-0 sm:max-w-none">
                            <slot name="image"></slot>
                        </div>
                        <div
                            class="pointer-events-none absolute inset-0 ring-1 ring-inset ring-black/10 sm:rounded-2xl"
                            aria-hidden="true"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
